import React, { useEffect, useState } from "react";
import { Box, Typography, Snackbar } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { handleCompanyCode } from "../../redux/reducers/authReducer";
import { unwrapResult } from "@reduxjs/toolkit";
import Logo from "../../assets/images/VSoftLogo.png";
import MuiAlert from "@mui/material/Alert";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
export default function CompanyLogin({ setStep, setLoading }) {
  const { t } = useTranslation("auth");
  const dispatch = useDispatch();
  const [subdomain, setSubdomain] = useState("");
  const [error, setError] = useState("");
  const handleClose = () => {
    setError(false);
  };
  useEffect(() => {
    const hostname = window.location.hostname;
    const extractedSubdomain = hostname.split(".")[0];
    setSubdomain(extractedSubdomain);

    if (extractedSubdomain === "clients") {
      setLoading(false);
      return;
    }

    setLoading(true);
    dispatch(
      handleCompanyCode({
        clientName: extractedSubdomain,
        // clientName: "Vsoftdemo",
        setLoading,
        setStep,
      })
    )
      .then(unwrapResult)
      .catch(() => {
        setLoading(false);
        setError("UserLogin", { message: t("Login.UserName_Error") });
      });
  }, [dispatch, setLoading, setStep]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        justifyContent: "center",
        alignItems: "center",
        gap: "35px",
        minWidth: "300px",
        minHeight: "400px",
        backgroundColor: "white",
        borderRadius: "15px",
        padding: "16px",
      }}
    >
      <img src={Logo} alt="Company Logo" />
      {subdomain === "clients" && (
        <>
          <Typography color="red" fontWeight="bold" fontSize={24}>
            تم تغيير هذا الرابط , برجاء التواصل مع شركة الشحن للحصول على الرابط
            الجديد
          </Typography>
          <Typography color="red" fontWeight="bold">
            This link has been changed, please contact the shipping company to
            get the new link
          </Typography>
        </>
      )}
      {error && (
        <Snackbar open={error} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
            <Box sx={{ px: 2 }}>{"Data Error"}</Box>
            <Box sx={{ px: 2 }}>{"خطأ فالبيانات"}</Box>
          </Alert>
        </Snackbar>
      )}
    </Box>
  );
}
